/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
// import 'gentelella/build/css/custom.min.css';
import swal from 'sweetalert';
import {
    Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import Stepper from './stepper';
import Tab1 from './tab1';
import Tab2 from './tab2';
import Tab3 from './tab3';
import Tab4 from './tab4';
import Tab5 from './tab5';
import Success from './success';

import { saveApplication, deleteApplication, getApplicationDetail } from './actions';
import { validateNRIC } from '../../utils/common';

import {
    getSalesforceToken,
    getPostalCodeRecord,
    getPersonField,
    getBeneficieryList,
    getHouseholdMembersList,
    getSchoolList,
    getApplyingToList,
    // getPostalCodes,
    saveObject,
    updateObject,
    getApplicationField,
    getRecordType, getLatestApplicationDetail, spmfcloudFunctionUrl,
} from '../../actions/salesforces';
import {
    getCurrentDate,
    validation,
} from '../../utils/common';
import '../../assets/css/form-style.css';

// import pdf from '../../static/spmf-application-form.pdf';

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: [{
                title: 'Start',
                href: '#',
                onClick: (e) => {
                    e.preventDefault();
                },
            }, {
                title: 'Application Profile ',
                href: '#',
                onClick: (e) => {
                    e.preventDefault();
                },
            }, {
                title: 'Beneficiaries List',
                href: '#',
                onClick: (e) => {
                    e.preventDefault();
                    console.log('onClick', 3);
                },
            }, {
                title: 'Other household members',
                href: '#',
                onClick: (e) => {
                    e.preventDefault();
                },
            }, {
                title: 'Agreement',
                href: '#',
                onClick: (e) => {
                    e.preventDefault();
                },
            }],
            renewalApplication: props.user.loggedInUser ? (props.user.loggedInUser.Partner_Authority__c === null) : false,
            currentStep: 0,
            tabIndex: 0,
            nodeList: [],
            RecordType: { HouseholdMember: '0125D0000008awbQAA', Beneficiary: '0125D0000008awgQAA' },
            employStatusList: [],
            relationList: [],
            householdMemberRelationList: [],
            relationListFiltered: [],
            isValidMainEmail: true,
            isValidBenEmail: ['true'],
            isValidBenNric: [''],
            isValidMainNric: [''],
            isValidHouNric: [''],
            schoolList: [],
            applyingToList: [],
            IDTypeList: [],
            nationList: [],
            Application_Status__c: 'Received',
            raceList: [],
            OtherSourceIncList: [],
            msList: [],
            schoolMap: {},
            // data
            check1: true,
            check2: true,
            check3: true,
            check4: true,
            check5: true,
            check6: true,
            check7: true,
            check8: true,
            check9: true,
            check10: true,
            // Application
            Alcoholism__c: false,
            Applicant__c: '',
            Application__c: '',
            Application_Type__c: '',
            Chronic_Illness__c: false,
            City__c: '',
            Country__c: 'Singapore',
            Cultural_or_personal_belief__c: false,
            Date_of_Application__c: getCurrentDate(),
            Declaration_Completed__c: '',
            Disability__c: false,
            Drug_Addiction__c: false,
            Flat_Type__c: '',
            Other_Flat_Type__c: '',
            Gambling_Addiction__c: false,
            Home_Ownership__c: '',
            Low_Education__c: false,
            Media_Coverage_consent__c: '',
            Other_Reason__c: '',
            Other_Reason_Description__c: '',
            Other_Source_of_Income__c: '',
            Other_Source_of_Income_Amount__c: '',
            Postal__c: '',
            Person__c: '',
            Block__c: '',
            Reason_s_for_Single_No_income_earner__c: '',
            Related_Account__c: '',
            Social_Visit_Pass__c: false,
            Source_of_Application__c: 'SPMF_Website',
            Street__c: '',
            Temporarily_unfit_for_work__c: false,
            Unit_Number__c: '',
            // Person
            Company__c: '',
            Contact_Number__c: '',
            Current_Level__c: '',
            Date_of_Birth__c: '',
            Email_Address__c: '',
            Employment_Status__c: '',
            Full_Name__c: '',
            Gender__c: '',
            currLevelList: [],
            Home_Phone__c: '',
            ID_Number__c: '',
            ID_Type__c: 'NRIC',
            Main_Applicant__c: true,
            Marital_Status__c: '',
            Mobile_Phone__c: '',
            Monthly_Gross_Income__c: '',
            Nationality__c: 'Singaporean',
            Race__c: '',
            Occupation__c: '',
            Office_Number__c: '',
            Other_Marital_Status__c: '',
            Other_Nationality__c: '',
            Other_Race__c: '',
            Other_Religion__c: '',
            Relationship_to_Applicant__c: 'Self',
            Relationship_to_Beneficiary_Other__c: '',
            Relationship_to_Beneficiary__c: '',
            Religion__c: '',
            Remarks__c: '',
            Stream__c: '',
            Ben: [{
                data: {
                    Date_of_Birth__c: '',
                    ID_Type__c: 'NRIC',
                    Applying_to__c: props.user.loggedInUser.Account ? props.user.loggedInUser.Account.Id : '',
                    Payout_Start__c: moment().format('YYYY-MM-DD').toString(),
                },
                attachment: {},
            }],
            Hou: [{ attachment: {}, data: { Main_Applicant__c: true } }],
            HouStatusEmployement: [''],
            isLoading: true,
            fullUrl: '',
            isSubmitted: false,
            applicationInfo: {},
            postalCodes: [],
            applicationId: null,
            draftId: '',
        };
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrev = this.onClickPrev.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.submitApp = this.submitApp.bind(this);
        this.changeState = this.changeState.bind(this);
        this.save = this.save.bind(this);
        this.update = this.update.bind(this);
        this.retrieve = this.retrieve.bind(this);
        this.saveApplication = saveApplication.bind(this);
        this.deleteApplication = deleteApplication.bind(this);
        this.getApplicationDetail = getApplicationDetail.bind(this);
    }

    async componentWillMount() {
        try {
            if (this.props.user.loggedInUser === undefined || this.props.user.loggedInUser === null) return;
            // Record Type set from redux
            // Set RecordType IDs based on SF environment i.e. development or production
            // Should be in redux not in local state
            const { recordType } = this.props.salesforce;
            const { user } = this.props;
            this.setState({ RecordType: recordType });
            if (this.props.user.loggedInUser.Partner_Authority__c === null) {
                await this.props.getLatestApplicationDetail(user.loggedInUser.AccountId, user.siteToken.hash, user.key);
                await this.props.getBeneficieryList(user.loggedInUser.AccountId, user.siteToken.hash, user.key);

                if (this.props.salesforce.applicationInfo.data.records.length > 0) {
                    // a0o5D000000LROpQAO
                    await this.props.getHouseholdMembersList(this.props.salesforce.applicationInfo.data.records[0].Application__c,
                        user.siteToken.hash, user.key);
                    // await this.props.getHouseholdMembersList('a0o5D000000LROpQAO', this.props.user.siteToken.hash);
                    console.log('componentWillUnmount55454');
                    const {
                        Full_Name__c,
                        Other_Race__c,
                        Race__c,
                        Nationality__c,
                        Other_Nationality__c,
                        Contact_Number__c,
                        Gender__c,
                        Date_of_Birth__c,
                        Office_Number__c,
                        Marital_Status__c,
                        ID_Number__c, Occupation__c,
                        Mobile_Phone__c, Email_Address__c,
                        Employment_Status__c,
                        Other_Marital_Status__c, Monthly_Gross_Income__c,
                        Company__c, Application__c,
                    } = this.props.salesforce.applicationInfo.data.records[0];
                    const { Other_Source_of_Income__c, Other_Source_of_Income_Amount__c } = this.props.salesforce.applicationInfo.data.records[0].Application__r;

                    this.setState({
                        Full_Name__c,
                        Email_Address__c,
                        Mobile_Phone__c,
                        Other_Race__c,
                        Race__c,
                        Nationality__c,
                        Office_Number__c,
                        Contact_Number__c,
                        Other_Nationality__c,
                        Gender__c,
                        ID_Number__c,
                        Employment_Status__c,
                        Date_of_Birth__c,
                        Marital_Status__c,
                        Other_Marital_Status__c,
                        Other_Source_of_Income__c,
                        Other_Source_of_Income_Amount__c,
                        Monthly_Gross_Income__c,
                        Occupation__c,
                        Company__c,
                        Application__c,
                        Person__c: Array.isArray(this.props.salesforce.applicationInfo.data.records) ? this.props.salesforce.applicationInfo.data.records[0].Id : '',
                    }, () => {
                        console.log('set state');
                        console.log(this.state);
                    });
                    const benData = [];
                    const temp = this.removeDuplicates(this.props.salesforce.beneficieryInfo.data.records, 'ID_Number__c');

                    temp.map((item) => {
                        benData.push({ data: item, attachment: {} });
                    });
                    const houData = [];
                    this.props.salesforce.householdMembersList.data.records.map((item) => {
                        if (item.Relationship_to_Applicant__c !== 'Self') {
                            houData.push({ data: item, attachment: {} });
                        } else {
                            houData.unshift({ data: item, attachment: {} });
                        }
                    });
                    this.setState({
                        Ben: benData,
                        Hou: houData,
                    });
                }
            }

            const params = new URLSearchParams(window.location.search);

            if (params.get('renewFrom') || this.props.match.params.registrationId) {
                let json = null;

                if (params.get('renewFrom')) {
                    // Retrieve completed application based on params.get('renewFrom') to clone from
                    json = await this.getApplicationDetail(params.get('renewFrom'));
                } else if (this.props.match.params.registrationId) {
                    // Start retrieving the saved application draft from MongoDB
                    const resp = await fetch(`${spmfcloudFunctionUrl}/db/applications/${this.props.match.params.registrationId}`, {
                        mode: 'cors',
                        cache: 'no-cache',
                        method: 'GET',
                        headers: {
                            'hash-token': this.props.user.siteToken.hash,
                        },
                    });

                    json = await resp.json();
                    if (!resp.ok) {
                        throw new Error(json.message);
                    }
                }

                const {
                    person,
                    application,
                    householdMembers,
                    beneficiary,
                } = json.data;

                this.setState({
                    // Person
                    Company__c: person.Company__c,
                    Contact_Number__c: person.Contact_Number__c,
                    Current_Level__c: person.Current_Level__c,
                    Current_School__c: person.Current_Level__c,
                    Email_Address__c: person.Email_Address__c,
                    Employment_Status__c: person.Employment_Status__c,
                    Full_Name__c: person.Full_Name__c,
                    Gender__c: person.Gender__c,
                    Home_Phone__c: person.Home_Phone__c,
                    ID_Number__c: person.ID_Number__c,
                    ID_Type__c: person.ID_Type__c,
                    Main_Applicant__c: true,
                    Marital_Status__c: person.Marital_Status__c,
                    Mobile_Phone__c: person.Mobile_Phone__c,
                    Monthly_Gross_Income__c: person.Monthly_Gross_Income__c,
                    Nationality__c: person.Nationality__c,
                    Occupation__c: person.Occupation__c,
                    Office_Number__c: person.Office_Number__c,
                    Other_Marital_Status__c: person.Other_Marital_Status__c,
                    Other_Nationality__c: person.Other_Nationality__c,
                    Other_Race__c: person.Other_Race__c,
                    Other_Religion__c: person.Other_Religion__c,
                    PDPA_Consent__c: person.PDPA_Consent__c ? person.PDPA_Consent__c : false,
                    Race__c: person.Race__c,
                    Relationship_to_Beneficiary__c: person.Relationship_to_Beneficiary__c,
                    Relationship_to_Beneficiary_Other__c: person.Relationship_to_Beneficiary_Other__c,
                    Religion__c: person.Religion__c,
                    Remarks__c: person.Remarks__c,
                    Stream__c: person.Stream__c,
                    Date_of_Birth__c: person.Date_of_Birth__c || '',

                    // Application
                    Alcoholism__c: application.Alcoholism__c,
                    Applicant__c: application.Applicant__c,
                    Application_Status__c: 'Received',
                    Application_Type__c: application.Application_Type__c,
                    Block__c: application.Block__c,
                    City__c: application.City__c,
                    Chronic_Illness__c: application.Chronic_Illness__c,
                    Country__c: application.Country__c,
                    Cultural_or_personal_belief__c: application.Cultural_or_personal_belief__c,
                    Date_of_Application__c: moment(new Date()),
                    Disability__c: application.Disability__c,
                    Flat_Type__c: application.Flat_Type__c,
                    Other_Flat_Type__c: application.Other_Flat_Type__c,
                    // Full_Name__c: application.Full_Name__c,
                    Gambling_Addiction__c: application.Gambling_Addiction__c,
                    Home_Ownership__c: application.Home_Ownership__c,
                    Low_Education__c: application.Low_Education__c,
                    Other_Source_of_Income__c: application.Other_Source_of_Income__c,
                    // if Other_Source_of_Income_Amount__c is numeric zero, it'll trigger an error on validation
                    // ../../utils/common.js line 299 (if (data[step4Field]) {...)
                    Other_Source_of_Income_Amount__c: `${application.Other_Source_of_Income_Amount__c}`,
                    Postal__c: application.Postal__c,
                    Reason_s_for_Single_No_income_earner__c: application.Reason_s_for_Single_No_income_earner__c,
                    Related_Account__c: application.Related_Account__c,
                    Social_Visit_Pass__c: application.Social_Visit_Pass__c,
                    Source_of_Application__c: application.Source_of_Application__c,
                    Street__c: application.Street__c,
                    Temporarily_unfit_for_work__c: application.Temporarily_unfit_for_work__c,
                    Unit_Number__c: application.Unit_Number__c,
                    Media_Coverage_consent__c: application.Media_Coverage_consent__c,

                    // Household
                    Hou: householdMembers,

                    // Beneficiaries
                    Ben: beneficiary,
                });
            }
            this.setState({ isLoading: false });
        } catch (err) {
            console.error(err);
            swal({
                html: true,
                icon: 'error',
                title: 'Error',
                text: err.message,
            });
        }
    }

    componentDidMount() {
        this.props.getSalesforceToken().then(() => {
            Promise.all([
                this.props.getSchoolList(() => { }),
                this.props.getApplyingToList(() => { }),
                // this.props.getPostalCodes(),

            ]).then(() => {
                const schoolList = [];
                const levelSchoolMap = [];
                const schoolMap = {};
                this.props.salesforce.schoolList.fields.records.map((field) => {
                    schoolList.push({ type: field.Partner_SubType__c, value: field.Id, label: field.Name });
                });

                // this.state.schoolList = schoolList;
                const applyingToList = [];
                this.props.salesforce.applyingToList.fields.records.map((atlItem) => {
                    applyingToList.push({ type: atlItem.Partner_SubType__c, value: atlItem.Id, label: atlItem.Name });
                    levelSchoolMap.push({ [atlItem.Name]: atlItem.Partner_SubType__c });
                    schoolMap[atlItem.Id] = atlItem.Name;
                });

                this.setState({
                    schoolList,
                    applyingToList,
                    levelSchoolMap,
                    schoolMap,
                });
                // this.state.applyingToList = applyingToList;
                // this.state.levelSchoolMap = levelSchoolMap;
                // this.state.schoolMap = schoolMap;
                this.forceUpdate();
                // this.setState({schoolMap: schoolMap});
            });
            this.retrieve('Person__c/describe').then((json) => {
                const { fields } = json;
                fields.sort((a, b) => {
                    if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                    if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                    return 0;
                });
                fields.map((item) => {
                    if (item.name === 'Current_Level__c') {
                        this.state.currLevelList = item.picklistValues;
                    }
                    if (item.name === 'Employment_Status__c') {
                        this.state.employStatusList = item.picklistValues;
                    }
                    if (item.name === 'Race__c') {
                        this.state.raceList = item.picklistValues;
                    }
                    if (item.name === 'Relationship_to_Applicant__c') {
                        this.state.relationList = item.picklistValues;
                    }
                    if (item.name === 'Relationship_to_Beneficiary__c') {
                        this.state.householdMemberRelationList = item.picklistValues;
                    }
                    if (item.name === 'Stream__c') {
                        this.state.streamList = item.picklistValues;
                    }
                    if (item.name === 'Marital_Status__c') {
                        this.state.msList = item.picklistValues;
                    }
                    if (item.name === 'Nationality__c') {
                        this.state.nationList = item.picklistValues;
                    }
                    if (item.name === 'ID_Type__c') {
                        this.state.IDTypeList = item.picklistValues;
                    }
                });
                this.filterRelationships();
            });
            this.retrieve('Application__c/describe').then((json) => {
                const appFields = json.fields;
                appFields.sort((a, b) => {
                    if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                    if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                    return 0;
                });
                appFields.map((appField) => {
                    if (appField.name === 'Flat_Type__c') {
                        const flatTypeOpt = [];
                        appField.picklistValues.map((val) => {
                            flatTypeOpt.push(val);
                        });
                        this.setState({
                            flatTypeList: appField.picklistValues,
                        });
                    }
                    if (appField.name === 'Other_Source_of_Income__c') {
                        const otherSourceOpt = appField.picklistValues;
                        this.state.OtherSourceIncList = otherSourceOpt;
                    }
                });
            });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', (event) => {
        });
    }

    onClickNext() {
        let isValidSpouse = true; // false;
        const { steps, currentStep, tabIndex } = this.state;
        if (currentStep > 0) {
            const validate = validation(currentStep + 1, this.state);
            let { isValid } = validate;
            let validNric = null;
            const { invalidFields, invalidFiles } = validate;

            const validFormat = currentStep === 1 ? this.state.isValidMainEmail : !this.state.isValidBenEmail.includes('false');

            if (currentStep === 1) {
                // this.setState({
                //     currentStep: currentStep + 1,
                //     tabIndex: tabIndex + 1,
                // });

                // Relying on this.state.isValidMainNric is proven to be too problematic and hardly debuggable
                // validNric = this.state.isValidMainNric;
                validNric = this.state.ID_Type__c === 'Others' ? true : validateNRIC(this.state.ID_Number__c);
            }
            if (currentStep === 2) {
                // this.setState({
                //     currentStep: currentStep + 1,
                //     tabIndex: tabIndex + 1,
                // });

                validNric = !this.state.isValidBenNric.includes('false');
            }
            if (currentStep === 3) {
                // this.setState({
                //     currentStep: currentStep + 1,
                //     tabIndex: tabIndex + 1,
                // });
                const data = this.state.Hou;
                const index = this.state.renewalApplication ? 0 : 1;

                const mustHaveSpouse = ['Married', 'Remarried'];
                if (!mustHaveSpouse.includes(this.state.Marital_Status__c)) {
                    // For unmarried people, isValidSpouse will always be true
                    isValidSpouse = true;
                }

                /* for (let i = index; i < data.length; i++) {
                    if (this.state.Marital_Status__c === 'Married' || this.state.Marital_Status__c === 'Remarried') {
                        if (this.state.Gender__c === 'Male' && data[i].data.Relationship_to_Applicant__c === 'Wife') {
                            isValidSpouse = true;
                        } else if (this.state.Gender__c === 'Female' && data[i].data.Relationship_to_Applicant__c === 'Husband') {
                            isValidSpouse = true;
                        }
                    }
                } */

                if (!isValidSpouse) {
                    isValid = false;
                }
                validNric = !this.state.isValidHouNric.includes('false');
            }
            // isValid = true;
            if (!validFormat) {
                swal('Invalid Format Email');
            }
            if (!validNric) {
                swal('Invalid Format NRIC/FIN');
            }
            if (!isValid) {
                let warningText = '';
                if (invalidFields.length > 0) {
                    if (currentStep === 2) {
                        invalidFields.map((fieldItem, idx) => {
                            let temp = fieldItem;
                            const beneNum = Number(fieldItem.match(/\d+/)[0]);
                            // #328 to change msg text for nric /birth certificate
                            if (fieldItem.replace(`Ben${beneNum}`, '').replace('[', '').replace(']', '') === 'ID Number') {
                                temp = `Ben${beneNum}[NRIC/Birth Cert No.]`;
                            }

                            if (idx === 0) {
                                warningText += `The following fields are missing in beneficiary ${beneNum} :\n`;
                                warningText += `\t- ${temp.replace(`Ben${beneNum}`, '').replace('[', '').replace(']', '')}\n`;
                            }

                            if (idx > 0) {
                                if (beneNum !== Number(invalidFields[idx - 1].match(/\d+/)[0])) {
                                    warningText += `\n The following fields are missing in beneficiary ${beneNum} :\n`;
                                    warningText += `\t- ${temp.replace(`Ben${beneNum}`, '').replace('[', '').replace(']', '')}\n`;
                                } else {
                                    warningText += `\t- ${temp.replace(`Ben${beneNum}`, '').replace('[', '').replace(']', '')}\n`;
                                }
                            }
                        });
                    }
                    if (currentStep === 3) {
                        if (!isValidSpouse) {
                            warningText += '\nPlease Select Your Spouse as well.\n';
                        }

                        invalidFields.map((fieldItem, idx) => {
                            const HouNum = Number(fieldItem.match(/\d+/)[0]);
                            if (idx === 0) {
                                warningText += `The following fields are missing in household member ${HouNum} :\n`;
                                warningText += `\t- ${fieldItem.replace(`Hou${HouNum}`, '').replace('[', '').replace(']', '')}\n`;
                            }
                            if (idx > 0) {
                                if (HouNum !== Number(invalidFields[idx - 1].match(/\d+/)[0])) {
                                    warningText += `\nThe following fields are missing in household member ${HouNum} :\n`;
                                    warningText += `\t- ${fieldItem.replace(`Hou${HouNum}`, '').replace('[', '').replace(']', '')}\n`;
                                } else {
                                    warningText += `\t- ${fieldItem.replace(`Hou${HouNum}`, '').replace('[', '').replace(']', '')}\n`;
                                }
                            }
                        });
                    }
                    if (currentStep === 1) {
                        invalidFields.map((invalidField) => {
                            let fieldName = '';
                            if (invalidField === 'Other Flat Type') {
                                fieldName = 'Specify Other HDB Flat Types';
                            } else {
                                fieldName = invalidField.replace('_', ' ');
                            }
                            warningText += `${fieldName}\n`;
                        });
                        swal({
                            html: true,
                            icon: 'warning',
                            title: 'Cannot move to next step',
                            text: warningText,
                        });
                    }
                } else if (currentStep === 3) {
                    if (!isValidSpouse) {
                        warningText += '\nPlease Select Your Spouse as well.\n';
                    }
                    swal({
                        html: true,
                        icon: 'warning',
                        title: 'Cannot move to next step. The fields below are required:',
                        text: warningText,
                    });
                }

                if (invalidFiles.length > 0) {
                    if (currentStep === 2) {
                        invalidFiles.map((fileItem, idx) => {
                            const benFileNum = Number(fileItem.match(/\d+/)[0]);
                            warningText += `\nPlease upload NRIC/Birth Cert File for Beneficiary ${benFileNum}\n`;
                        });
                    }
                    if (currentStep === 3) {
                        invalidFiles.map((fileItem, idx) => {
                            const houFileNum = Number(fileItem.match(/\d+/)[0]);
                            if (idx === 0) {
                                warningText += `\nThe following files are missing in household member ${houFileNum} :\n`;
                                warningText += `\t- ${fileItem.replace(`Hou${houFileNum}`, '')}\n`;
                            } if (idx > 0) {
                                if (houFileNum !== Number(invalidFiles[idx - 1].match(/\d+/)[0])) {
                                    warningText += `\nThe following files are missing in household member ${houFileNum} :\n`;
                                    warningText += `\t- ${fileItem.replace(`Hou${houFileNum}`, '')}\n`;
                                } else {
                                    warningText += `\t- ${fileItem.replace(`Hou${houFileNum}`, '')}\n`;
                                }
                            }
                        });
                    }
                    window.scrollTo(0, 0);
                } else {
                    swal({
                        icon: 'warning',
                        title: 'Cannot move to next step, please fill all required fields',
                    });
                }
                swal({
                    html: true,
                    icon: 'warning',
                    title: 'Cannot move to next step.',
                    text: warningText,
                });
            }
            if (validNric && validFormat && isValid) {
                this.setState({
                    currentStep: currentStep + 1,
                    tabIndex: tabIndex + 1,
                });
            }
        } else {
            this.setState({
                currentStep: currentStep + 1,
                tabIndex: tabIndex + 1,
            });
        }
    }

    onClickPrev() {
        const { steps, currentStep, tabIndex } = this.state;
        this.setState({
            currentStep: currentStep - 1,
            tabIndex: tabIndex - 1,
        });
    }

    onSelect() { }

    filterRelationships() {
        const relationshipList = ['Son', 'Daughter', 'Step son', 'Step daughter', 'Ward', 'Grandchild', 'Others'];
        const relationshipListForBeneficiary = this.state.relationList.filter(relation => relationshipList.includes(relation.value));

        this.setState({
            relationListFiltered: relationshipListForBeneficiary,
        });
    }

    removeDuplicates(originalArray, prop) {
        const newArray = [];
        const lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    changeState(name, val) {
        this.setState({
            [name]: val,
        });
    }

    retrieve(sobjects) {
        const SF_VERSION = 'v20.0';
        const salesforceToken = this.props.salesforce.token;
        if (salesforceToken !== null) {
            this.setState({ fullUrl: `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/${sobjects}` });
        }
        const fetchConfig = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            timeout: 5000,
        };
        return fetch(this.state.fullUrl, fetchConfig).then(response => response.json());
    }

    async save(sobjects, data) {
        const SF_VERSION = 'v37.0';
        const salesforceToken = this.props.salesforce.token;
        if (salesforceToken !== null) {
            this.setState({ fullUrl: `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/${sobjects}` });
        }
        let headers = {
            Authorization: `Bearer ${salesforceToken.accessToken}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
        };
        if (sobjects === 'Attachment') {
            headers = {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Disposition': 'form-data;name="entity_document"',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            };
        }
        const fetchConfig = {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
            timeout: 5000,
        };
        const response = await fetch(this.state.fullUrl, fetchConfig);
        const json = await response.json();
        if (!response.ok) throw new Error(JSON.stringify(json));

        return json;
    }

    async update(sobjects, id, data) {
        const SF_VERSION = 'v37.0';
        const salesforceToken = this.props.salesforce.token;
        if (salesforceToken !== null) {
            this.setState({ fullUrl: `${salesforceToken.instanceUrl}/services/data/${SF_VERSION}/sobjects/${sobjects}/${id}` });
        }
        const fetchConfig = {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${salesforceToken.accessToken}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            body: JSON.stringify(data),
            timeout: 5000,
        };

        const response = await fetch(this.state.fullUrl, fetchConfig);
        const json = await response.json();
        if (!response.ok) throw new Error(JSON.stringify(json));

        return json;
    }

    applicationRenewalFunc() {
        const personData = {
            Company__c: this.state.Company__c,
            Contact_Number__c: this.state.Contact_Number__c,
            Current_Level__c: this.state.Current_Level__c,
            Current_School__c: this.state.Current_Level__c,
            Email_Address__c: this.state.Email_Address__c,
            Employment_Status__c: this.state.Employment_Status__c,
            Full_Name__c: this.state.Full_Name__c,
            Gender__c: this.state.Gender__c,
            Home_Phone__c: this.state.Home_Phone__c,
            ID_Number__c: this.state.ID_Number__c,
            ID_Type__c: this.state.ID_Type__c,
            Main_Applicant__c: true,
            Marital_Status__c: this.state.Marital_Status__c,
            Mobile_Phone__c: this.state.Mobile_Phone__c,
            Monthly_Gross_Income__c: this.state.Monthly_Gross_Income__c,
            Nationality__c: this.state.Nationality__c,
            Occupation__c: this.state.Occupation__c,
            Office_Number__c: this.state.Office_Number__c,
            Other_Marital_Status__c: this.state.Other_Marital_Status__c ? this.state.Other_Marital_Status__c : '',
            Other_Nationality__c: this.state.Other_Nationality__c ? this.state.Other_Nationality__c : '',
            Other_Race__c: this.state.Other_Race__c,
            Other_Religion__c: this.state.Other_Religion__c,
            PDPA_Consent__c: this.state.PDPA_Consent__c ? this.state.PDPA_Consent__c : false,
            Race__c: this.state.Race__c,
            Relationship_to_Beneficiary__c: this.state.Relationship_to_Beneficiary__c,
            Religion__c: this.state.Religion__c,
            Remarks__c: this.state.Remarks__c,
            Stream__c: this.state.Stream__c,
        };
        if (this.state.Date_of_Birth__c !== '') {
            personData.Date_of_Birth__c = this.state.Date_of_Birth__c;
        }
        const applicationData = {
            Alcoholism__c: this.state.Alcoholism__c,
            Applicant__c: this.state.Applicant__c,
            Application_Status__c: this.state.Application_Status__c || '',
            Application_Type__c: this.state.Application_Type__c,
            Block__c: this.state.Block__c,
            City__c: this.state.City__c,
            Chronic_Illness__c: this.state.Chronic_Illness__c,
            Country__c: this.state.Country__c,
            Cultural_or_personal_belief__c: this.state.Cultural_or_personal_belief__c,
            Date_of_Application__c: this.state.Date_of_Application__c,
            Disability__c: this.state.Disability__c,
            Flat_Type__c: this.state.Flat_Type__c,
            Other_Flat_Type__c: this.state.Other_Flat_Type__c,
            Full_Name__c: this.state.Full_Name__c,
            Gambling_Addiction__c: this.state.Gambling_Addiction__c,
            Home_Ownership__c: this.state.Home_Ownership__c,
            Low_Education__c: this.state.Low_Education__c,
            Other_Source_of_Income__c: this.state.Other_Source_of_Income__c,
            Other_Source_of_Income_Amount__c: this.state.Other_Source_of_Income_Amount__c,
            Postal__c: this.state.Postal__c,
            Reason_s_for_Single_No_income_earner__c: this.state.Reason_s_for_Single_No_income_earner__c,
            Related_Account__c: this.state.Related_Account__c,
            Social_Visit_Pass__c: this.Social_Visit_Pass__c ? this.Social_Visit_Pass__c : '',
            Source_of_Application__c: this.state.Source_of_Application__c,
            Street__c: this.state.Street__c,
            Temporarily_unfit_for_work__c: this.state.Temporarily_unfit_for_work__c,
            Unit_Number__c: this.state.Unit_Number__c,
            Media_Coverage_consent__c: this.state.Media_Coverage_consent__c,
        };

        const salesforceToken = this.props.salesforce.token;
        saveObject('Application__c', applicationData, salesforceToken).then((json1) => {
            const applicationId = json1.id;
            personData.Application__c = applicationId;
            this.setState({ applicationId });
            if (applicationId !== undefined) {
                personData.Name = `${applicationId}-1`;
                saveObject('Person__c', personData, salesforceToken).then((json2) => {
                    const personId = json2.id;
                    const dataToUpdate = { Applicant__c: personId };
                    updateObject('Application__c', applicationId, dataToUpdate, salesforceToken).then((json3) => {
                        console.log(json3);
                    });
                    if (this.state.Hou[0].attachment.file1 !== undefined) {
                        this.state.Hou[0].attachment.file1.ParentId = personId;
                        this.save('Attachment', this.state.Hou[0].attachment.file1).then((resAttach) => {
                            console.log('personAttachfile1', resAttach);
                        }).catch((err) => { alert(err); });
                    }
                    if (this.state.Hou[0].attachment.file2 !== undefined) {
                        this.state.Hou[0].attachment.file2.ParentId = personId;
                        this.save('Attachment', this.state.Hou[0].attachment.file2).then((resAttach) => {
                            console.log('personAttachfile2', resAttach);
                        }).catch((err) => { alert(err); });
                    }
                    if (this.state.Hou[0].attachment.file3 !== undefined) {
                        this.state.Hou[0].attachment.file3.ParentId = personId;
                        this.save('Attachment', this.state.Hou[0].attachment.file3).then((resAttach) => {
                            console.log('personAttachfile3', resAttach);
                        }).catch((err) => { alert(err); });
                    }
                }); /* end Of save Main Applicant */
                /*  save BenData */
                this.state.Ben.map((beneficiary, index) => {
                    const benData = beneficiary;
                    benData.data.Application__c = applicationId;
                    benData.data.RecordType = {
                        Name: 'Beneficiary',
                    };
                    benData.data.Application_Status__c = 'Received';
                    // benData.data.No_of_Receipts_Approved__c='';
                    // benData.data.Payout_Start__c='';

                    // needs to remove the id key as it was giving error while creating
                    delete benData.data.Name;
                    delete benData.data.Id;
                    delete benData.data.Contact_Name__r;
                    delete benData.data.Application__r;
                    this.save('Person__c', benData.data).then((resBen) => {
                        const benId = resBen.id;
                        if (benData.attachment.Name !== undefined) {
                            benData.attachment.ParentId = benId;
                            console.log('benesave', resBen);
                            this.save('Attachment', benData.attachment).then((resBenAttach) => {
                                console.log('beneattach', resBenAttach);
                            }).catch((err) => { alert(err); });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                }); /* end of save BenData */
                /* save HouData */
                this.state.Hou.map((houData, idx) => {
                    if (idx !== 0) {
                        console.log(houData);
                        houData.data.Application__c = applicationId;
                        console.log('  houData.data');
                        console.log(houData.data);
                        delete houData.data.Id;
                        delete houData.data.Application__r;
                        this.save('Person__c', {
                            ...houData.data,
                            PDPA_Consent__c: this.state.PDPA_Consent__c || false,
                        }).then((resHou) => {
                            console.log('resHou', resHou);

                            const personHouId = resHou.id;
                            if (houData.attachment.file1 !== undefined) {
                                houData.attachment.file1.ParentId = personHouId;
                                this.save('Attachment', houData.attachment.file1).then((resHouAttach) => {
                                    console.log('houattach', resHouAttach);
                                }).catch((err) => { alert(err); });
                            }
                            if (houData.attachment.file2 !== undefined) {
                                houData.attachment.file2.ParentId = personHouId;
                                this.save('Attachment', houData.attachment.file2).then((resHouAttach) => {
                                    console.log('houattach', resHouAttach);
                                }).catch((err) => { alert(err); });
                            }
                            if (houData.attachment.file3 !== undefined) {
                                houData.attachment.file3.ParentId = personHouId;
                                this.save('Attachment', houData.attachment.file3).then((resHouAttach) => {
                                    console.log('houattach', resHouAttach);
                                }).catch((err) => { alert(err); });
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }); /*  end of save HouData */
            }
        }).then(() => {
            this.setState({ isSubmitted: true });
        })
            .catch((err) => {
                swal({
                    icon: 'error',
                    text: 'Failed request application',
                });
            });/* end of submit to SF process */

        return true;
    }

    async applicationFormFunc(exportData = false) {
        try {
            const personData = {
                Company__c: this.state.Company__c,
                Contact_Number__c: this.state.Contact_Number__c,
                Current_Level__c: this.state.Current_Level__c,
                Current_School__c: this.state.Current_Level__c,
                Email_Address__c: this.state.Email_Address__c,
                Employment_Status__c: this.state.Employment_Status__c,
                Full_Name__c: this.state.Full_Name__c,
                Gender__c: this.state.Gender__c,
                Home_Phone__c: this.state.Home_Phone__c,
                ID_Number__c: this.state.ID_Number__c,
                ID_Type__c: this.state.ID_Type__c,
                Main_Applicant__c: true,
                Marital_Status__c: this.state.Marital_Status__c,
                Mobile_Phone__c: this.state.Mobile_Phone__c,
                Monthly_Gross_Income__c: this.state.Monthly_Gross_Income__c,
                Nationality__c: this.state.Nationality__c,
                Occupation__c: this.state.Occupation__c,
                Office_Number__c: this.state.Office_Number__c,
                Other_Marital_Status__c: this.state.Other_Marital_Status__c,
                Other_Nationality__c: this.state.Other_Nationality__c,
                Other_Race__c: this.state.Other_Race__c,
                Other_Religion__c: this.state.Other_Religion__c,
                PDPA_Consent__c: this.state.PDPA_Consent__c ? this.state.PDPA_Consent__c : false,
                Race__c: this.state.Race__c,
                Relationship_to_Beneficiary__c: this.state.Relationship_to_Beneficiary__c,
                Relationship_to_Beneficiary_Other__c: this.state.Relationship_to_Beneficiary_Other__c,
                Religion__c: this.state.Religion__c,
                Remarks__c: this.state.Remarks__c,
                Stream__c: this.state.Stream__c,
                Date_of_Birth__c: this.state.Date_of_Birth__c || '',
            };

            const applicationData = {
                Alcoholism__c: this.state.Alcoholism__c,
                Applicant__c: '',
                Application_Status__c: this.state.Application_Status__c,
                Application_Type__c: this.state.Application_Type__c,
                Block__c: this.state.Block__c,
                City__c: this.state.City__c,
                Chronic_Illness__c: this.state.Chronic_Illness__c,
                Country__c: this.state.Country__c,
                Cultural_or_personal_belief__c: this.state.Cultural_or_personal_belief__c,
                Date_of_Application__c: this.state.Date_of_Application__c,
                Disability__c: this.state.Disability__c,
                Flat_Type__c: this.state.Flat_Type__c,
                Other_Flat_Type__c: this.state.Other_Flat_Type__c,
                Full_Name__c: this.state.Full_Name__c,
                Gambling_Addiction__c: this.state.Gambling_Addiction__c,
                Home_Ownership__c: this.state.Home_Ownership__c,
                Low_Education__c: this.state.Low_Education__c,
                Other_Source_of_Income__c: this.state.Other_Source_of_Income__c,
                Other_Source_of_Income_Amount__c: this.state.Other_Source_of_Income_Amount__c,
                Postal__c: this.state.Postal__c,
                Reason_s_for_Single_No_income_earner__c: this.state.Reason_s_for_Single_No_income_earner__c,
                Related_Account__c: this.state.Related_Account__c,
                Social_Visit_Pass__c: this.Social_Visit_Pass__c,
                Source_of_Application__c: this.state.Source_of_Application__c,
                Street__c: this.state.Street__c,
                Temporarily_unfit_for_work__c: this.state.Temporarily_unfit_for_work__c,
                Unit_Number__c: this.state.Unit_Number__c,
                Media_Coverage_consent__c: this.state.Media_Coverage_consent__c,
            };

            if (exportData) {
                // To save application draft in MongoDB
                return {
                    person: personData,
                    application: applicationData,
                    householdMembers: this.state.Hou,
                    beneficiary: this.state.Ben,
                };
            }

            const salesforceToken = this.props.salesforce.token;

            const json1 = await saveObject('Application__c', applicationData, salesforceToken);

            const applicationId = json1.id;
            personData.Application__c = applicationId;

            this.setState({ applicationId });

            if (applicationId !== undefined) {
                personData.Name = `${applicationId}-1`;

                const json2 = await saveObject('Person__c', personData, salesforceToken);
                const personId = json2.id;
                const dataToUpdate = { Applicant__c: personId };

                await updateObject('Application__c', applicationId, dataToUpdate, salesforceToken, true);

                if (this.state.Hou[0].attachment.file1 !== undefined) {
                    const { file1 } = this.state.Hou[0].attachment;
                    file1.ParentId = dataToUpdate.Applicant__c;
                    file1.Description = 'nric_fin_file';
                    delete file1.Id;
                    await this.save('Attachment', file1);
                }

                if (this.state.Hou[0].attachment.file2 !== undefined) {
                    const { file2 } = this.state.Hou[0].attachment;
                    file2.ParentId = dataToUpdate.Applicant__c;
                    file2.Description = 'cpmf_statement';
                    delete file2.Id;
                    await this.save('Attachment', file2);
                }

                if (this.state.Hou[0].attachment.file3 !== undefined) {
                    const { file3 } = this.state.Hou[0].attachment;
                    file3.ParentId = dataToUpdate.Applicant__c;
                    file3.Description = 'payslip';
                    delete file3.Id;
                    await this.save('Attachment', file3);
                }
                /* end Of save Main Applicant */

                /*  save BenData */
                const promiseList = this.state.Ben.map(async (benData, index) => {
                    benData.data.Application__c = applicationId;
                    // benData.data.RecordTypeId = this.state.RecordType.Beneficiary;
                    benData.data.RecordTypeId = this.props.salesforce.recordType.Beneficiary;
                    delete benData.data.Name;
                    delete benData.data.Id;
                    delete benData.data.Application__r;
                    delete benData.data.attributes;
                    // delete benData.data.RecordType;
                    return this.save('Person__c', benData.data);
                });

                const resolvedList = await Promise.all(promiseList);
                const promiseList2 = resolvedList.map(async (resBen, index) => {
                    const benId = resBen.id;
                    const benData = this.state.Ben[index];

                    if (benData.attachment.Name !== undefined) {
                        benData.attachment.ParentId = benId;
                        benData.attachment.Description = 'bene_nric_fin_file';
                        delete benData.attachment.Id;
                        return this.save('Attachment', benData.attachment);
                        // const resBenAttach = await this.save('Attachment', benData.attachment);
                        // console.log('beneattach', resBenAttach);
                    }

                    return null;
                });

                await Promise.all(promiseList2);
                /* end of save BenData */

                /* save HouData */
                const houPromiseList = this.state.Hou.map(async (houData, idx) => {
                    if (idx !== 0) {
                        houData.data.Application__c = applicationId;
                        // houData.data.RecordTypeId = this.state.RecordType.HouseholdMember;
                        houData.data.RecordTypeId = this.props.salesforce.recordType.Household_Member;
                        delete houData.data.Id;
                        delete houData.data.Application__r;
                        delete houData.data.attributes;
                        // delete houData.data.RecordType;

                        return this.save('Person__c', houData.data);
                    }

                    return null;
                });

                const houResolvedList = await Promise.all(houPromiseList);
                const attachmentList = [];
                for (let a = 0; a < houResolvedList.length; a++) {
                    const houData = this.state.Hou[a];
                    const resHou = houResolvedList[a];
                    if (resHou) {
                        const personHouId = resHou.id;

                        if (houData.attachment.file1 !== undefined) {
                            houData.attachment.file1.ParentId = personHouId;
                            delete houData.attachment.file1.Id;
                            attachmentList.push(this.save('Attachment', houData.attachment.file1));
                        }
                        if (houData.attachment.file2 !== undefined) {
                            houData.attachment.file2.ParentId = personHouId;
                            delete houData.attachment.file2.Id;
                            attachmentList.push(this.save('Attachment', houData.attachment.file2));
                        }
                        if (houData.attachment.file3 !== undefined) {
                            houData.attachment.file3.ParentId = personHouId;
                            delete houData.attachment.file3.Id;
                            attachmentList.push(this.save('Attachment', houData.attachment.file3));
                        }
                    }
                }

                await Promise.all(attachmentList);
                /*  end of save HouData */
            }

            // NOTE: If the application is previously saved as a draft in MongoDB, delete the draft now
            if (this.props.match.params.registrationId || this.state.draftId) {
                await this.deleteApplication();
            }

            this.setState({ isSubmitted: true, draftId: '' });
        } catch (err) {
            if (this.state.isLoading) this.setState({ isLoading: false });
            swal({
                icon: 'error',
                text: `Failed request application. ${err.message}`,
            });
        }
    }

    async submitApp() {
        this.setState({ isLoading: true });

        if (this.state.renewalApplication) {
            this.applicationRenewalFunc();
        } else {
            await this.applicationFormFunc();
        }

        this.setState({ isLoading: false });
    }

    render() {
        const { steps, currentStep } = this.state;
        const buttonStyle = {
            background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32,
        };
        let buttonprev = null;
        let buttonnext = null;

        let downloadUrl = 'https://cs72.salesforce.com/sfc/p/5D0000008epl/a/5D0000004Fwk/EeFgrql3OYCa91hZfyfTER2eKjATPRhj89SWo3P75d8';

        if (!window.__DEV__) {
            downloadUrl = 'https://ap5.salesforce.com/sfc/p/#7F000002bBSH/a/7F000000LVZe/3uQdgZcYsR.qVkepey52f_n_2E0RZnDCacxYB2N2MHE';
        }

        let saveButton = (
            <button
                onClick={this.saveApplication}
                className="btn btn-warning btn-100"
                title="Save the application so you could resume filling it later"
            >
                Save
            </button>
        );

        if (currentStep > 0) {
            buttonprev = <button onClick={this.onClickPrev} className="btn btn-warning btn-100">Prev</button>;
        } else {
            buttonprev = '';
            saveButton = '';
        }
        if (currentStep === 4) {
            buttonnext = '';
        } else if (this.state.check1 && this.state.check2 && this.state.check4
            && this.state.check5 && this.state.check6 && this.state.check7
            && this.state.check8 && this.state.check9 && this.state.check10) {
            buttonnext = <button onClick={this.onClickNext} className="btn step" disabled={this.state.isLoading}>Next</button>;
        } else {
            buttonnext = <button onClick={this.onClickNext} className="btn" disabled>Next</button>;
        }
        if (!this.state.isSubmitted) {
            return (
                <div className="registrationForm container-fluid">
                    <div className="container body col-lg-12 col-sm-12 col-xs-12 col-md-12" id="printed">
                        <div className="col-md-12" id="logoHeader">
                            <div className="col-md-2">
                                <img src={require('../../assets/img/spmf_logo.jpg')} alt="SPMF Logo" width="150px" />
                            </div>
                            <div className="col-md-8">
                                <br /><br />
                                <h3 style={{ color: '#0590ba' }}>&nbsp;&nbsp;STSPMF Application Form</h3>
                            </div>
                            <div className="col-md-2">
                                <a
                                    href={downloadUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-info btn-fill text-right"
                                >
                                    <i className="fa fa-download" /> Download
                                </a>
                            </div>
                        </div>
                        {this.state.isLoading ? <div><i className="fa text-center fa-spinner fa-spin fa-3x fa-fw" /></div>
                            : (
                                <div className="" id="AppForm">
                                    <div className="col-md-12 stepper">
                                        <Stepper
                                            steps={steps}
                                            activeStep={currentStep}
                                            completeColor="white"
                                            completeTitleColor="white"
                                            // circleFontSize={18}
                                            circleFontColor="#1bb4e2"
                                            activeColor="white"
                                            activeTitleColor="white"
                                            completeBarColor="white"
                                        />
                                    </div>
                                    {/* this.state.tabIndex */}
                                    <Tabs
                                        selectedIndex={this.state.tabIndex}
                                        forceRenderTabPanel
                                        onSelect={this.onSelect}
                                    >
                                        <TabList style={{ display: 'none' }}>
                                            <Tab>Title 1</Tab>
                                            <Tab>Title 2</Tab>
                                            <Tab>Title 3</Tab>
                                            <Tab>Title 4</Tab>
                                            <Tab>Title 5</Tab>
                                        </TabList>
                                        <div id="PrintedForm">
                                            <TabPanel>
                                                <Tab1
                                                    changeState={this.changeState}
                                                    data={this.state}
                                                />
                                            </TabPanel>
                                            <TabPanel>
                                                <Tab2
                                                    changeState={this.changeState}
                                                    data={this.state}
                                                    postalCodes={this.state.postalCodes}
                                                />
                                            </TabPanel>
                                            <TabPanel>
                                                <Tab3
                                                    changeState={this.changeState}
                                                    data={this.state}
                                                />
                                            </TabPanel>
                                            <TabPanel>
                                                <Tab4
                                                    changeState={this.changeState}
                                                    data={this.state}
                                                    maritalStatus={this.state.Marital_Status__c}
                                                />
                                            </TabPanel>
                                            <TabPanel>
                                                <Tab5
                                                    changeState={this.changeState}
                                                    submitApp={this.submitApp}
                                                    data={this.state}
                                                    applicationId={this.state.applicationId}
                                                />
                                            </TabPanel>
                                        </div>
                                    </Tabs>
                                    <br />
                                    <div className="text-center">
                                        <br />
                                        {buttonprev}
                                        {saveButton}
                                        {buttonnext}
                                    </div>
                                </div>
                            )
                        }
                        <iframe
                            id="ifmcontentstoprint"
                            title="ifmcontentstoprint"
                            style={{
                                height: '0px', width: '0px', position: 'absolute', pageBreakAfter: 'always',
                            }}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="registrationForm">
                <Success data={this.state} />
                <center>
                    {/* <a
                        href={null}
                        className="btn btn-default"
                        onClick={(e) => {
                            e.preventDefault();
                            const otherWindow = window.open();
                            otherWindow.opener = null;
                            otherWindow.location = `${spmfcloudFunctionUrl}/application-attachment/${this.state.applicationId}?token=${this.props.user.siteToken.hash}`;
                        }}
                    >
                        <i className="fa fa-print" /> Print
                    </a> */}
                    {this.state.applicationId
                        ? (
                            <a
                                href={`${spmfcloudFunctionUrl}/application-attachment/${this.state.applicationId}?token=${this.props.user.siteToken.hash}`}
                                className="btn btn-default"
                            >
                                <i className="fa fa-print" /> Print
                            </a>
                        )
                        : null
                    }
                </center>
            </div>
        );
    }
}

Registration.propTypes = {
    getSalesforceToken: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    salesforce: PropTypes.object.isRequired,
};
Registration.defaultProps = {
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
        getSalesforceToken,
        getLatestApplicationDetail,
        getPostalCodeRecord,
        getPersonField,
        getSchoolList,
        getApplyingToList,
        getApplicationField,
        getBeneficieryList,
        //  getPostalCodes,
        getHouseholdMembersList,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});


export default connect(mapStateToProps, mapDispatchToProps)(Registration);



//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/index.js
// module id = 1032
// module chunks = 0